import React from 'react'
import * as TypeUtil from '../util/TypeUtil'
import * as DataUtil from '../util/DataUtil'
import * as Util from '../util/Util'
import About from './About'
//import {PrivacyTerms} from './About'

export default class Terms extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentDidMount() {
    const filePath = `/md/terms.md`
    DataUtil.fetchText(filePath, (text)=>{
      const template = text
      if (TypeUtil.isNonEmptyString(template)) {
        const content = Util.fromTemplate(template)(About)
        if (TypeUtil.isNonEmptyString(content)) {
          this.setState({content:content})
        }
      }
    })
  }
  render() {
    return (
      <div className="main-content">
        {
          TypeUtil.isNonEmptyString(this.state.content)&&
          <div
          dangerouslySetInnerHTML={Util.fromMd(this.state.content)}
          />
        }
      </div>
    )
  }
}
